import { Component } from 'preact'
import ShowMoreButton from './ShowMoreButton'
import QuickLinksList from './QuickLinksList'
import QuickLink from './QuickLink'
import Phrase from '../../libs/translationsUtils/phrase'

export default class QuickLinksContainer extends Component {
  constructor (props) {
    super()

    this.state = {
      showAll: props.showAll
    }
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  showMoreHandler () {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  render (props, state) {
    const { data, settings, itemsPerContainer, isKnowledgeBase } = props
    const { showAll } = state

    return (
      <section class='full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper'>
        {isKnowledgeBase &&
        <h2 class='knowledgeBase__heading'><Phrase p='knowledge.base.homepage.title' /></h2>}

        <div class='sitewidth'>
          <div class='col'>
            <QuickLinksList isKnowledgeBase={isKnowledgeBase}>
              { data.map((item, idx) => <QuickLink
                item={item}
                idx={idx}
                enableBorder={settings.enableBorder}
                borderRadius={settings.borderRadius}
                isVisibleDesktop={showAll || idx < itemsPerContainer}
                isKnowledgeBase={isKnowledgeBase} />)}
            </QuickLinksList>
          </div>
        </div>
        {(data.length > itemsPerContainer && !isKnowledgeBase) &&
          <ShowMoreButton
            quickLinksLength={data.length}
            itemsPerContainer={itemsPerContainer}
            showMore={this.showMoreHandler}
            showAll={showAll} />}
      </section>
    )
  }
}
